import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenSpinner } from "../components/exports";
import { getAuthManager } from "../utils/auth";

export default function Callback() {
    const navigate = useNavigate();

    useEffect(() => {
        const auth = getAuthManager();

        auth.completeAuthentication(
            (user) => {
                const redirectUrl = localStorage.getItem("redirect-url") ?? "/";
                localStorage.removeItem("redirect-url");
                navigate(redirectUrl);
            },
            () => {
                navigate("/login");
            }
        );
    }, [navigate]);

    return <FullScreenSpinner />;
}
